import querystring from 'querystring';

// const TRAXXID_API_HOST = "http://localhost:8181/api";
// const TRAXXID_API_HOST = "https://dev.traxx.id/api";
const TRAXXID_API_HOST = 'https://app.traxx.id/api';

// const TRAXXASIA_API_HOST = 'http://localhost:8181/api';
// const TRAXXASIA_API_HOST = 'https://demo.traxxasiabackend.traxx.id/api';
const TRAXXASIA_API_HOST = 'https://traxxasiabackend.traxx.id/api';

const PATHS = {};

// PATHS['compliance'] = '/compliance/compliance';
// PATHS['countries/list'] = '/account/screen/info/countries';
PATHS['auth/login'] = '/auth/session/login';

PATHS['applications'] = '/application/list';
PATHS['updateCurrentStatus'] = '/application/updateCurrentStatus';
PATHS['analytics'] = '/application/analytics';
PATHS['search'] = '/application/search';

/**
 * Converts api path key and query parameters to the actual api link to the backend
 *
 * @param {string} prefix - the prefix used to refer to respective hostname 
 * @param {string} key - the key used to refer to the list of api paths
 * @param {string} query_params - query parameters
 * @param {string} route_params - routing parameters
 *
 * @return {string} - the api url used to call the backend
 */
export function get_api_path(prefix, key, query_params, route_params = {}) {
  let HOSTNAME;
  switch (prefix) {
    case 'traxxid':
      HOSTNAME = TRAXXID_API_HOST;
      break;
    case 'traxxasia':
      HOSTNAME = TRAXXASIA_API_HOST;
      break;
    default:
      throw new Error('invalid api hostname');
  }

  let url = HOSTNAME + PATHS[key];
  // eslint-disable-next-line no-unused-vars
  for (const paramKey in route_params) url = url.replace(`:${paramKey}`, route_params[paramKey]);

  if (query_params) url += '?' + querystring.stringify(query_params);
  return url;
}
